// Client-side replacements for Next.js server helpers
// These read from cookies/localStorage instead of using next/headers

import type { Settings } from '@core/contexts/settingsContext'
import type { SystemMode } from '@core/types'
import themeConfig from '@configs/themeConfig'

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))

  
return match ? decodeURIComponent(match[2]) : undefined
}

export const getSettingsFromCookie = (): Settings => {
  try {
    const cookieName = themeConfig.settingsCookieName
    const raw = getCookie(cookieName)

    
return raw ? JSON.parse(raw) : {}
  } catch {
    return {} as Settings
  }
}

export const getMode = () => {
  const settingsCookie = getSettingsFromCookie()

  
return settingsCookie.mode || themeConfig.mode
}

export const getSystemMode = (): SystemMode => {
  const mode = getMode()
  const colorPref = getCookie('colorPref') as SystemMode | undefined

  return (mode === 'system' ? colorPref || 'light' : mode) as SystemMode || 'light'
}

export const getServerMode = () => {
  const mode = getMode()
  const systemMode = getSystemMode()

  
return mode === 'system' ? systemMode : mode
}

export const getSkin = () => {
  const settingsCookie = getSettingsFromCookie()

  
return settingsCookie.skin || 'default'
}
